import React from 'react';
import './GiftCardSkeleton.css';

function GiftCardSkeleton() {
  return (
    <article className="gift-card gift-card--skeleton" aria-hidden="true">
      <div className="gift-card__media skeleton-block skeleton-block--media" />
      <div className="gift-card__body">
        <div className="skeleton-block skeleton-block--title" />
        <div className="skeleton-block skeleton-block--badge" />
        <div className="skeleton-block skeleton-block--date" />
        <div className="skeleton-block skeleton-block--button" />
      </div>
    </article>
  );
}

export function GiftGridSkeleton({ count = 6 }) {
  return (
    <div className="gifts-grid" aria-busy="true" aria-label="Loading listings">
      {Array.from({ length: count }, (_, i) => (
        <GiftCardSkeleton key={i} />
      ))}
    </div>
  );
}

export default GiftCardSkeleton;
